import { AxiosInstance } from 'axios'

import { SpringPaginationResult } from './pagination'

import { CommunityMedicalTipQuery, CommunityMedicalTipView } from '../../contracts/community'

export * from '../../contracts/community/UserMedicalTipView'

export interface CommunityMedicalTipPagination {
  pageIndex: number
  pageSize: number
  pageSorts: {
    pageSortField: 'IDENTIFIER' | 'CREATED_DATE' | 'UPDATED_DATE' | 'PUBLISHED_DATE'
    pageSortOrder: 'ASC' | 'DESC'
  }[]
}

export class CommunityMedicalTip {
  constructor(private axios: AxiosInstance) {}

  async getMedicalTips(
    pagination: CommunityMedicalTipPagination,
  ): Promise<SpringPaginationResult<CommunityMedicalTipView>> {
    const { data } = await this.axios.request<SpringPaginationResult<CommunityMedicalTipView>>({
      url: '/community/medical-tip/queries/get-medical-tips/process',
      method: 'post',
      data: {
        pagination,
      },
    })

    return data
  }

  async getMedicalTip(query: CommunityMedicalTipQuery): Promise<CommunityMedicalTipView> {
    const { data } = await this.axios.request<CommunityMedicalTipView>({
      url: '/community/medical-tip/queries/get-medical-tip/process',
      method: 'post',
      data: query,
    })

    return data
  }
}
